{% block sw_extension_type_label %}
    <div>
        {% block sw_extension_type_label_self_hosted %}
            <sw-extension-label>
                {{ $t('sw-extension-store.typeLabels.self-hosted') }}
            </sw-extension-label>
        {% endblock %}

        {% block sw_extension_type_label_cloud %}
            <sw-extension-label
                v-if="isApp"
                class="sw-extension-type-label__cloud-label"
            >
                {{ $t('sw-extension-store.typeLabels.cloud') }}
            </sw-extension-label>
        {% endblock %}
    </div>
{% endblock %}
